import script from "./landItem.vue?vue&type=script&setup=true&lang=js"
export * from "./landItem.vue?vue&type=script&setup=true&lang=js"

import "./landItem.vue?vue&type=style&index=0&id=04fecbfc&scoped=true&lang=less"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04fecbfc"]])

export default __exports__